<template>
    <div class="block-editor youtube-set-moderation-status">
        <section>
            <div class="title">{{ $t('auto.youTubeSetModerationStatusChannelId') }}</div>
            <TiptapEditor placeholder="YouTube Channel ID" :show-attributes="true" v-model="clone.channelId" automation-mode />
            <small>{{ $t('auto.youTubeSetModerationStatusModerasyonYapLacakYorumunBulunduUKanalIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeSetModerationStatusCommentId') }}</div>
            <TiptapEditor placeholder="YouTube Comment ID" :show-attributes="true" v-model="clone.commentId" automation-mode />
            <small>{{ $t('auto.youTubeSetModerationStatusModerasyonDurumuDeITirilecekYorumunIdsi') }}</small>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeSetModerationStatusModerasyonDurumu') }}</div>
            <a-select v-model="clone.moderationStatus" class="classic-select" :placeholder="$t('auto.youTubeSetModerationStatusModerasyonDurumuSeIniz')">
                <a-select-option value="published">{{ $t('auto.youTubeSetModerationStatusYayNlaPublished') }}</a-select-option>
                <a-select-option value="heldForReview">{{ $t('auto.youTubeSetModerationStatusNcelemeyeAlHeldforreview') }}</a-select-option>
                <a-select-option value="rejected">{{ $t('auto.youTubeSetModerationStatusReddetRejected') }}</a-select-option>
            </a-select>
        </section>
        <section>
            <div class="title">{{ $t('auto.youTubeSetModerationStatusYorumSahibiniBanla') }}</div>
            <a-switch v-model="clone.banAuthor" />
            <small class="ban-warning" v-if="clone.banAuthor">{{ $t('auto.youTubeSetModerationStatusDikkatBuKullanCKanalNZdaBirDahaYorumYapamayacak') }}</small>
        </section>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";
export default {
    name: "YouTubeSetModerationStatus",
    components: {
        TiptapEditor,
    },
    props: ["value"],
    data() {
        return {
            clone: _.cloneDeep({
                channelId: "",
                commentId: "",
                moderationStatus: "published",
                banAuthor: false,
                ...this.value
            }),
        };
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.youtube-set-moderation-status {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    section {
        margin-bottom: 20px;
    }

    .title {
        font-weight: bold;
        margin-bottom: 5px;
    }

    .classic-select {
        width: 100%;
    }

    small {
        color: #777;
        
        &.ban-warning {
            color: #ff4d4f;
            font-weight: 500;
        }
    }
}
</style>
